import { IconProps } from ".";
import Icon from "./assets/change_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Change(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
